import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04153c8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-content" }
const _hoisted_2 = { class: "pdf-title" }
const _hoisted_3 = { class: "mt-4 border-top-1" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-8" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs" }, " Folgende technische Anlagen wurden im Rahmen einer visuellen Bestandserfassung der Technikzentralen vorgefunden: "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, " Abwasser- Wasser- Gasanlagen Mischentwässerung von Abwasse "),
  /*#__PURE__*/_createElementVNode("p", { class: "my-1 text-xs" }, " Mischentwässerung von Abwasser und Regenwasser inkl. Rückstauschutz über 5 Hebeanlage. Trinkwasserversorgung über 2 Bereiche. Eine Niederdruckzone und ab dem 2.OG eine Hochdruckzone über eine Druckerhöhungsanlage. Es existiert eine Enthärtungsanlage, Sprinklerwasser wird über eine Trennstation bereitgestellt. Keine Gasanlagen. "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, " Titel "),
  /*#__PURE__*/_createElementVNode("p", { class: "my-1 text-xs" }, " Beschreibung "),
  /*#__PURE__*/_createElementVNode("p", { class: "mb-0 font-bold text-xs" }, " Titel "),
  /*#__PURE__*/_createElementVNode("p", { class: "my-1 text-xs" }, " Beschreibung ")
], -1))
const _hoisted_6 = { class: "my-16 border-top-1" }
const _hoisted_7 = { class: "text-xs my-8 flex flex-wrap" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-nowrap items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-center" }, "Mangelkategorien:")
], -1))
const _hoisted_9 = { class: "flex flex-nowrap items-center mx-2" }
const _hoisted_10 = { class: "flex flex-nowrap items-center mx-2" }
const _hoisted_11 = { class: "flex flex-nowrap items-center mx-2" }
const _hoisted_12 = { class: "flex flex-nowrap items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_acon_logo = _resolveComponent("pdf-acon-logo")!
  const _component_pdf_general_data = _resolveComponent("pdf-general-data")!
  const _component_generic_pdf_mgt_summary_table = _resolveComponent("generic-pdf-mgt-summary-table")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_pdf_a4_page, { "pdf-key": _ctx.lang }, {
      default: _withCtx(() => [
        _createVNode(_component_pdf_acon_logo),
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("immobilie.pdf.kopfzeile", 1, { locale: _ctx.lang})), 1),
        _createVNode(_component_pdf_general_data, {
          hzba: _ctx.hzba,
          immobilie: _ctx.immobilie,
          lang: _ctx.lang
        }, null, 8, ["hzba", "immobilie", "lang"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.t("immobilie.pdf.managementSummary", 1, { locale: _ctx.lang})), 1),
          _createVNode(_component_generic_pdf_mgt_summary_table, {
            data: _ctx.mangelDummyData,
            lang: _ctx.lang
          }, null, 8, ["data", "lang"])
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_PdfChip, {
                color: "green",
                "pdf-mode": ""
              }),
              _createTextVNode(" Keine Mängel ")
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_PdfChip, {
                color: "blue",
                "pdf-mode": ""
              }),
              _createTextVNode(" Keine relevanten Mängel ")
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_PdfChip, {
                color: "yellow",
                "pdf-mode": ""
              }),
              _createTextVNode(" Sicherheitsrelevante Mängel ")
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_PdfChip, {
                color: "red",
                "pdf-mode": ""
              }),
              _createTextVNode(" Versorgungsrelevante Mängel ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["pdf-key"])
  ]))
}